import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import SubmenuButton from "../components/SubmenuButton";
import Counter from "../../Counter";

import { sendNavigationMetric } from "../../../utils/sendMetric";

import { useStore } from "../../../connect";

import { MAIN_PAGE_QUERY_PARAM_STRING } from "../../../consts";

import strings from "../../../locales/strings";

const YourLoadsLink = ({ isTablet, color }) => {
  const { profile, header, baseUrl } = useStore();
  const counters = profile.user?.counters || {};

  return profile.isLoggedIn ? (
    <SubmenuButton
      href={`https://loads.${baseUrl}/published?utm_source=header&utm_campaign=new_header${
        header.isMainPage ? `&${MAIN_PAGE_QUERY_PARAM_STRING}` : ""
      }`}
      dataName="your-loads-link"
      color={color}
      icon="ic_cargo-out"
      counter={
        counters.loads_main && (
          <Counter maxValue={isTablet ? 9 : 99}>{counters.loads_main}</Counter>
        )
      }
      onClick={() => sendNavigationMetric("SUB_MENU_YOUR_LOADS")}
    >
      {strings.yourLoads}
    </SubmenuButton>
  ) : (
    <SubmenuButton
      onClick={header.handleYourLoadsClick}
      dataName="your-loads-link"
      color={color}
      icon="ic_cargo-out"
    >
      {strings.yourLoads}
    </SubmenuButton>
  );
};

YourLoadsLink.propTypes = {
  isTablet: PropTypes.bool,
  color: PropTypes.oneOf(["green", "yellow", "gray"]),
};

export default observer(YourLoadsLink);
